export interface CommandPaletteArgs {
  tab: 'search' | `chat.${'new' | 'history'}`
  query?: string
}

const [useEventsProvider, useEventsProvided] = createInjectionState(() => {
  const commandPalette = createEventHook<[event: 'open', args: CommandPaletteArgs]>()

  return {
    commandPalette,
  }
})

export { useEventsProvider }

export const useEvents = () => {
  const events = useEventsProvided()

  if (!events)
    throw new Error('useEvents must be used within a useEventsProvider')

  return events
}
